// Beta allowlist: only these subscriber (`_id`) values see the v2 "Messaging" menu option.
// Replace the placeholders below with the two real subscriber _id values.
export const MESSAGING_BETA_SUBSCRIBER_IDS: string[] = [
    '60ca3dcfd8b671906eb9bd26',
    '63eee96124b0841a7bab8895',
    '6267e9309bc3669c48d5989a',
    '6a7b176454c829b154afde7c',
    '6a7b172e54c829b154afde7b',
    '680a21772cdd8ee6f00ce342',
    '6596fda9e93e7e4f81696f8b',
    '652b0969386c72a0aa728c83',
    '652b1b10386c72a0aa728c85',
    '67183cc989bb05be7f591d79',
    '652b1bae386c72a0aa728c86',
    '67d8a17df3f9f0cf97c2339f',
    '68aeaba5d447acd72a0cf998',
    '6969e707e55ad3f56f4b1af1',
    '652b1424386c72a0aa728c84',
    '6a14d0aaa5b1729cdeb3444c',
    '6a21a3a3a5b1729cdeb3445e',
    '6a57fbd69bd70ff770206849',
    '6a14d019a5b1729cdeb3444b',
    '6a57fc229bd70ff77020684a',
    '6844859135b3abd804b2a389',
    '6a57fbbf9bd70ff770206848',
    '6a4bef11a22705382462f35c',
    '680b79c72cdd8ee6f00ce348',
    '6a8721b254c829b154afde98',
    '67024ad515ba7a1f28877124',
    '6a5b3b249bd70ff770206857',
    '698784d80e06582e629d6708',
    '669abc5dc3a155c596d7e6ef',
    '6a8726cc54c829b154afde99',
    '6164a80528d5fd25af28bd6f',
    '63134662d61199473a68eac7',
    '69fd9d309e4b97439717e61c',
    '654e79efb6669064f918b977',
    '68fb72bc662592caaf824840',
    '63134738d61199473a68eac8',
    '67f6b69596f176e27810ee3a',
    '61085fe88ed34f30989d3b5c',
    '610861538ed34f30989d3b83',
    '662aba8e13d6d2381b8bb2d7',
    '639a6798b0ac5eae86f90f95',
    '66f819a0838fcb24438db094',
    '69f3871a9e4b97439717e602',
    '67a29348cbe8c0991d931ada',
    '67a29342cbe8c0991d931ad9',
    '6751bf92e4f201e3f05c59ec',
    '656b53925da78861155a2949',
    '64cc2f010efb108f3faecf66',
    '6a5a15139bd70ff770206854',
    '645f70c85304a508735b9fda',
    '678fb066e91d263a907e653c',
    '645f676a5304a508735b9fd9',
    '62bb353aea35c474a18ab525',
    '62bb1cd8ea35c474a18ab524',
    '6799101de91d263a907e6555',
    '62bf27f40f62e5aea0dadd9a',
    '6abb876e16ed6ebef6cb133d',
    '682c6a2eceb268b770bb73ad',
    '6a7ac54154c829b154afde79',
    '66d2153f89e85a8e9913cf88',
    '64a6df45d0134e7455e7c983',
    '64b96c00e4da66d15fe0a6d4',
    '68e00c69e5282953bf8736ed',
    '67ec1de0dd2dcbfa515e11a1',
    '698240700e06582e629d6703',
    '67ec1daddd2dcbfa515e11a0',
    '64ba4989e4da66d15fe0a6d5',
    '6640bb5be3e6eb4ad33db7b5',
    '67d2e638f3f9f0cf97c2338e',
    '6547ed4d5160a1a1de811f69',
    '68835304d447acd72a0cf950',
    '655608a39c29f6cf2b5064bb',
    '67ed5b8a062f469c9d7e872c',
    '613654bcd7da20328d84ec91',
    '68d5bd3fe5282953bf8736d7',
    '63598b3b96183311ab29be51',
    '69131a99e5282953bf873783',
    '6267f14e9bc3669c48d5989e',
    '6267eee49bc3669c48d5989c',
    '6267f01e9bc3669c48d5989d',
    '635fce47bd5ab9873e077158',
    '6ac643f216ed6ebef6cb1369',
    '6aab0ce016ed6ebef6cb1324',
    '63924f87d6febaa65851f666',
    '6392720fd6febaa65851f667',
    '6ac589de16ed6ebef6cb1367',
    '6a1e7637a5b29f5256ca6a6d',
    '685027f6d447acd72a0cf927',
    '695ac9cee55ad3f56f4b1ae9',
    '6a0ec2e08f2ae0238920665b',
    '685d884b2d725f967a2a4af0',
    '667ee1105d22205dfe7b5337',
    '6a84658954c829b154afde8b',
    '69f086789e4b97439717e5ff',
    '6a4801a0a22705382462f35a',
    '656351815da78861155a2928',
    '6a15c390a5b1729cdeb3444e',
    '6931a0a163fca9120b69d303',
    '69b4299efd07b4a61d3f5537',
    '634ae595a8c03205f8a44822',
    '680272d996f176e27810ee67',
    '64ef496efb2820ec7a2becf3',
    '6ac5140316ed6ebef6cb135f',
    '69d8bb9f9e4b97439717e5bb',
    '681204102cdd8ee6f00ce367',
    '66512f7a5d69585cde53ae7c',
    '64ef48d3fb2820ec7a2becf2',
    '6a6b6fc454c829b154afde46',
    '69abc6ecfd07b4a61d3f5518',
    '634ae6f0a8c03205f8a44823',
    '66c76ef46dea31cee89c7944',
    '6821b852ceb268b770bb7389',
    '69d8bca49e4b97439717e5bc',
    '698b5d44fd07b4a61d3f53fd',
    '6ac6cdc916ed6ebef6cb136c',
    '65393085386c72a0aa728c98',
    '65312bc1386c72a0aa728c8f',
    '665f06d75d69585cde53ae86',
    '69810f6e0e06582e629d66fd',
    '6ac7f22616ed6ebef6cb136d',
    '610864ab8ed34f30989d3bde',
    '6169687a28d5fd25af19fd67',
    '681a77a69051f512d9f6fdd6',
    '6107e2c9ebfb11f83b989250',
    '69603077015d332893d6758c',
    '62c3224da5f44cb724b95eb2',
    '642fe8614b152f72dbaeaac3',
    '664b273e5d69585cde53ae75',
    '6787e145e91d263a907e6512',
    '67059c8815ba7a1f28877139',
    '698f49be92c83f488202aa00',
    '6ac95fe016ed6ebef6cb1372',
    '6ac937d516ed6ebef6cb1370',
    '664bbd4d5d69585cde53ae76',
    '69b165edfd07b4a61d3f552f',
    '610835f08ed34f30989d0a59',
    '6a9ef70316ed6ebef6cb130d',
    '66d0f11489e85a8e9913cf85',
    '65299b3d386c72a0aa728c81',
    '6ac68e9b16ed6ebef6cb136a',
    '66def460838fcb24438db063',
    '668566ff5d22205dfe7b5346',
    '68a60e7bd447acd72a0cf98b',
    '6aca424b16ed6ebef6cb1374',
    '634c3e6c9a24b6f2d19e03d9',
    '64ddf8cd0efb108f3faecf7b',
    '60e6df2db0e808c55d96a2b3',
    '636fa1382f03194d7816c840',
    '642eace14b152f72dbaeaabf',
    '66d9e582838fcb24438db04e',
    '66e4a9b2838fcb24438db07d',
    '66d9e68c838fcb24438db04f',
    '65691d5bc67a7baa6b817dd3',
    '66e9d192481adb415d198633',
    '65677a195da78861155a2935',
    '656cfbefc67a7baa6b817dd9',
    '68fff7e2662592caaf82484d',
    '6468e0e06f83655771811b27',
    '69025bf1507c21c5445f69ca',
    '6468e2116f83655771811b28',
    '64cc518146fc834b1b437804',
    '64cc50e146fc834b1b437803',
    '611268ccc4c75118f33d1605',
    '69949344fd07b4a61d3f540f',
    '6132a7a52cb413178bb81734',
    '6443ef36780b442eee91e076',
    '69b7eb3b92c83f488202aa21',
    '6443be4e780b442eee91e074',
    '6ad14eaa16ed6ebef6cb1385',
    '6ad0bdca16ed6ebef6cb1381',
    '661ebbf613d6d2381b8bb2bd',
    '61a406e945fc14ebc0225dbd',
    '61a405d145fc14ebc0225dbc',
    '6ad3867816ed6ebef6cb1389',
    '6935dbb663fca9120b69d30a',
    '69ab031afd07b4a61d3f5516',
    '69b51e75fd07b4a61d3f553e',
    '69aaabb0fd07b4a61d3f5514',
    '6ad698bf16ed6ebef6cb138c',
    '6ad76d7f16ed6ebef6cb138d',
    '669c29c6c3a155c596d7e6f5',
    '61a65444d1adfad9a90c362f',
    '61a6537bd1adfad9a90c362e',
    '622116c08bc052458131021e',
    '611e37db5b7e8b04f3e3eda6',
    '63f35f10e686a5143bd5baa0',
    '6a08464e9e4b97439717e633',
    '61a77701d1e9d4faada8d0e0',
    '6974f745015d332893d675c3',
    '6a143abca5b29f5256ca6a5c',
    '697263f9015d332893d675bc',
    '6804c9ff96f176e27810ee76',
    '6852c9a135b3abd804b2a3bb',
    '69751736015d332893d675c5',
    '680774091612a305781aaa22',
    '64b43c20ca0d60cfccafb869',
    '698bae8192c83f488202a9f6',
    '6852c99235b3abd804b2a3b9',
    '6971fa99e55ad3f56f4b1aff',
    '683b0b9cdc72452281d60b7b',
    '68013b0c96f176e27810ee65',
    '68013b0596f176e27810ee64',
    '69726405015d332893d675bd',
    '67f5852e1612a305781aaa10',
    '67fd60ef16924368ede196a3',
    '67fd60fc16924368ede196a4',
    '610867828ed34f30989d3c38',
    '686a848604f84059043206af',
    '672df185df60f7f8081e1acb',
    '6adfd32fc5776dcc32380ead',
    '6a1b5c54a5b29f5256ca6a68',
    '66ea6b12481adb415d19863a',
    '6733a672cc7208dff3f77606',
    '691b49c3dda239ef5a51bc77',
    '64d6bef346fc834b1b437818',
    '69988d81fd07b4a61d3f541c',
    '6185e98cc0d553808f0f3685',
    '617d631b5a247967d5908515',
    '65ef5aaa06f0496f86b157af',
    '64dce29746fc834b1b437826',
    '64255f74e840c519c278d724',
    '69dffe588f2ae0238920662e',
    '69dffe678f2ae0238920662f',
    '67f06e6cdd2dcbfa515e11aa',
    '6a942eee54c829b154afdead',
    '6a10cd4aa5b1729cdeb34441',
    '6ac953c916ed6ebef6cb1371',
    '69dffe418f2ae0238920662d',
    '6421e9583262b00a2f319773',
    '642944fde840c519c278d72d',
    '642945dde840c519c278d72e',
    '6969f058015d332893d675a9',
    '6a1e7637a5b29f5256ca6a6d',
    '69ee53029e4b97439717e5fc',
    '6478c38f39bdb2a5bc125daa',
    '61c0d970021921d371b881d0',
    '619b8891137cb8ef22ab53a0',
    '636fb3e32f03194d7816c842',
    '6633f5130de7667ab24896c4',
    '62fecefb71d2072982bc0d6a',
    '61effb9e7d6c15e32dbb7b1e',
    '640b0d24075cda7b32323a77',
    '64205070075cda7b32323ac4',
    '64669e776f83655771811b20',
    '6612d6565e9b1e70fb2e2b63',
    '67b1cd2cf3f9f0cf97c23320',
    '6ae79fcec5776dcc32380ec4',
    '697a2ad93f0178d02a566a87',
    '6ab6f70216ed6ebef6cb1338',
    '68dd9aafe5282953bf8736e8',
    '68dd9ad5e5282953bf8736e9',
    '6a9fc9fa16ed6ebef6cb130e',
    '69c4e1e6fd07b4a61d3f555c',
    '69a42b65fd07b4a61d3f5502',
    '69a42b6efd07b4a61d3f5503',
    '6189090b277019c706bb4bb7',
    '6837316b38210d71cc868a05',
    '6ae8c7cec5776dcc32380ec5',
    '692dc6cfdda239ef5a51bcae',
    '67a26419e91d263a907e6566',
    '64a9adacd0134e7455e7c98b',
    '672f2f0878c9a7f1888726c2',
    '63bc40168b7929d8aefa9ef6',
    '622f1641ef34fbda10de326f',
    '688f2ca7224d9bc3389e601f',
    '6157222a28d5fd25af7857a7',
    '64d23cc20efb108f3faecf70',
    '64c2972a46fc834b1b4377ef',
    '6252cf40d62319a79e12623c',
    '6a2dbd48a22705382462f348',
    '61a419ac45fc14ebc0225dbf',
    '630c0ba6063d2d042ca1490a',
];

/**
 * Whether the given subscriber is in the Messaging beta allowlist.
 */
export const isMessagingBetaSubscriber = (subscriberId?: string | null): boolean =>
    !!subscriberId && MESSAGING_BETA_SUBSCRIBER_IDS.includes(subscriberId);
